import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/Artikel',
    name: 'Artikel',
    query: {
      page: 1
    },
    component: () => import('@/components/Article/ArticleListe')
  },
  {
    path: '/ArtikelKurz',
    component: () => import('@/components/Article/ArticleShortList')
  },
  {
    path: '/Artikel/:id',
    component: () => import('@/components/Article/Article')
  },
  {
    path: '/:siteId-:site',
    component: () => import('@/components/CMS/Site')
  },
  {
    path: '/Warnung',
    component: () => import('@/components/Warning/WarningList')
  },
  {
    path: '/Kalender',
    component: () => import('@/components/Calendar/CalendarWrapper')
  },
  {
    path: '/Entschuldigung',
    component: () => import('@/components/Krankmeldung')
  },
  {
    path: '/:dropdownId-:dropdown/:siteId-:site',
    component: () => import('@/components/CMS/Site')
  },
  {
    path: '/Error',
    name: 'Error',
    component: () => import('@/views/Error'),
    props: true
  },
  {
    path: '/*',
    redirect: {
      name: 'Home'
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
